import { render, staticRenderFns } from "./TiersFiche.vue?vue&type=template&id=2c538d2e&"
import script from "./TiersFiche.vue?vue&type=script&lang=js&"
export * from "./TiersFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports